import config from '@config';
import { initializeHttpWithDefaultValues } from '@gasbi/shared/common/utils/http';

const instance = initializeHttpWithDefaultValues(config.VITE_API_URL);

export default instance;
